<video mat-dialog-content #videoPlayer controls [src]="video">
    Seu browser não suporta arquivos de vídeo
</video>

<mat-dialog-actions>
    <button mat-button (click)="videoPlayer.play()">Reproduzir</button>
    <button mat-button (click)="videoPlayer.pause()" mat-dialog-close>Sair</button>
</mat-dialog-actions>